import * as React from "react";
const SvgPayoutIcon = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", width: 20, height: 20, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4 10h3v7H4zm6.5 0h3v7h-3zM2 19h20v3H2zm15-9h3v7h-3zm-5-9L2 6v2h20V6z" }));
export default SvgPayoutIcon;
